import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Lead } from 'src/app/_types/lead.types';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { SendProposalsModalComponent } from 'src/app/shared/components/view-proposals/send-proposals-modal/send-proposals-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-send-lead-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    SendProposalsModalComponent,
    IconsModule,
  ],
  templateUrl: './send-lead.component.html',
})
export class SendLeadActionComponent extends BaseStepperAction {
  get enabled() {
    return (
      this.state?.insuranceFlowData?.status === InsuranceFlowStatus.PENDING_LEAD
    );
  }

  get lead(): Lead {
    return this.state?.lead;
  }
}
